import React from 'react';
import classNames from 'classnames/bind';
import PropTypes from 'prop-types';

// Components
import { Link, Text } from '@beef/ui-kit';
import { PackageList } from './PackageList';

import { usingOfferInfoShape, roamingParamShape, accumulatorShape, packageInfoShape } from '../../propTypes';

// Styles
import styles from './styles.pcss';

const cx = classNames.bind(styles);

const UsingOffer = ({ usingOfferInfo, roamingParams, accumulator, packageInfo }) => (
  <div>
    {usingOfferInfo && (
    <div className={cx('using-offer__expiration')}>
      <Text size="size6-r" color="grey60">
        {usingOfferInfo.expirationDate}
      </Text>
    </div>
    )}
    <PackageList
      params={roamingParams}
      accumulator={accumulator}
      isOffer={!!usingOfferInfo}
      packageInfo={packageInfo}
    />
    {usingOfferInfo && (
    <Link
      href={usingOfferInfo.buyBtnLink}
      variant="button"
      buttonVariant="main"
      buttonSize="s"
    >
      {usingOfferInfo.buyBtnText}
    </Link>
    )}
  </div>
);

UsingOffer.propTypes = {
  usingOfferInfo: usingOfferInfoShape,
  roamingParams: PropTypes.arrayOf(roamingParamShape),
  accumulator: PropTypes.arrayOf(accumulatorShape),
  packageInfo: PropTypes.arrayOf(packageInfoShape),
};

export { UsingOffer };
